<template>
  <div class="files">
    <OmxList
        :data="filesData"
        :loading="isLoading"
        :show-search="false"
        empty-icon="file-multiple-outline"
    >
      <template #actions>
        <OmxPermissionButton
            :allowed="currentUserAccess('ProjectFilesDetails', UserActions.CREATE, project_id)"
            type="is-primary" icon-left="plus-thick" @click="addNewFileClicked">
          {{ $t('files-view.new-file-button') }}
        </OmxPermissionButton>
      </template>

      <b-table-column field="name" :label="$t('files-view.file-name-column')" v-slot="props" sortable searchable>
        <a @click="downloadProjectFile(props.row)">{{ props.row.name }}</a>
      </b-table-column>
      <b-table-column field="email" :label="$t('files-view.email-column')" v-slot="props" sortable searchable>
        {{ props.row.email }}
      </b-table-column>
      <b-table-column field="description" :label="$t('files-view.description-column')" v-slot="props" sortable searchable>
        {{ props.row.description }}
      </b-table-column>
      <b-table-column field="date" :label="$t('files-view.date-column')" v-slot="props" sortable>
        {{ props.row.date }}
      </b-table-column>
      <b-table-column v-slot="props" cell-class="has-text-right" width="100">
        <b-button type="is-danger" size="is-small" icon-left="delete"
                  @click="deleteFileClicked(props.row)">
          {{ $t('files-view.delete') }}
        </b-button>
      </b-table-column>
    </OmxList>

    <b-modal
        v-model="isModalActive"
        trap-focus
        :destroy-on-hide="true"
        aria-role="dialog"
        aria-modal>
      <template #default="props">
        <FileUploadDetails :project_id="project_id" @close="props.close" @fileUploaded="readFiles" />
      </template>
    </b-modal>
  </div>
</template>

<script>
import FileUploadDetails from "@/components/FileUploadDetails";
import firebase from "firebase";
import OmxList from "@/components/OmxList.vue";

export default {
  name: "FilesList",
  components: {
    FileUploadDetails,
    OmxList
  },
  props: {
    'project_id': {
      type: String,
    }
  },
  data() {
    return {
      filesData: [],
      isLoading: false,
      isModalActive: false
    }
  },
  methods: {
    readFiles: function () {
      this.isModalActive = false;
      this.isLoading = true;
      this.filesData = [];
      this.getFilesRef().listAll().then((res) => {
        res.items.forEach((itemRef) => {
          itemRef.getMetadata()
              .then((metadata) => {
                if (metadata !== null && metadata !== undefined) {
                  itemRef['date'] = this.getFormattedDateTime(metadata.timeCreated)
                  if (metadata.customMetadata !== null && metadata.customMetadata !== undefined) {
                    itemRef['description'] = metadata.customMetadata.description
                    itemRef['email'] = metadata.customMetadata.email
                  }
                }
                this.filesData.push(itemRef)
              })
              .catch((error) => {
                console.log("error reading project files meta: ", error?.code);
              });
        });
        this.isLoading = false;
      }).catch((error) => {
        console.log("error reading project files: ", error?.code);
        this.isLoading = false;
      });
    },
    getFilesRef: function () {
      const filesPath = this.getStorageRootFolder() + '/projects/' + this.project_id + '/files'
      return firebase.storage().ref(filesPath)
    },
    addNewFileClicked: function () {
      this.isModalActive = true;
    },
    downloadProjectFile: function (fileRef) {
      fileRef.getDownloadURL().then((downloadURL) => {
        window.open(downloadURL);
      }).catch((error) => {
        console.log('project file download url error: ', error?.code);
      });
    },
    async deleteFileClicked(fileRef) {
      const ok = await this.$omxConfirm({
        title: this.$t('files-view.delete-file-title').toString(),
        message: this.$t('files-view.delete-file-message').toString(),
        confirmText: this.$t('files-view.delete-file-button').toString(),
        cancelText: this.$t('common.cancel').toString(),
        type: 'is-danger',
        icon: 'delete'
      });
      if (ok) this.deleteFile(fileRef);
    },
    deleteFile: function (fileRef) {
      this.isLoading = true;
      fileRef.delete().then(() => {
        this.isLoading = false;
        this.showSuccess(this.$t("files-view.file-deleted"))
        this.readFiles();
      }).catch((error) => {
        this.isLoading = false;
        this.showError(error.message)
        console.log('error deleting project file: ', error?.code);
      });
    }
  },
  computed: {},
  mounted() {
    this.readFiles()
  }
}
</script>